import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromState from './branchchampions.state';

const { selectIds, selectEntities, selectAll, selectTotal } = fromState.adapter.getSelectors();

export const selectBranchChampionsState = createFeatureSelector<fromState.BranchChampionsState>(fromState.branchChampionsEntityKey);

export const selectBranchChampionsIds = createSelector(
    selectBranchChampionsState,
    selectIds,
);

export const selectBranchChampionsEntities = createSelector(
    selectBranchChampionsState,
    selectEntities,
);

export const selectAllBranchChampionsItemsPresent = createSelector(
    selectBranchChampionsState,
    selectAll,
);

export const selectBranchChampionsItemsPresentCount = createSelector(
    selectBranchChampionsState,
    selectTotal,
);

export const selectBranchChampionsByMonth = (month: string) => createSelector(
    selectAllBranchChampionsItemsPresent,
    (entries: fromState.BranchChampionsEntity[]) => {
        return entries.filter((champion) => {
            if (champion.data) {
                const filteredTeam = champion.data.filter((entry) => {
                    if (entry.month) {
                        return entry.month === month;
                    }
                    return false;
                });
                return filteredTeam.length > 0;
            }
            return false;
        })
    });
